import React, {Fragment} from "react";
import {connect} from "react-redux";
import {
    Space,
    Button,
    Form,
    Modal,
    Input,
    Row,
    Col,
    DatePicker,
    Select,
    Card,
    Radio,
    message,
    Switch
} from "antd";
import {createContentRule, loadContentRule, updateContentRule} from "../../actions/domains";
import moment from "moment";
import {PlusOutlined} from "@ant-design/icons";
import FirewallRuleCondition from "../firewall/FirewallRuleCondition";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import countryList from "react-select-country-list";
import {displayErrors} from "../../libs/utils";
import {loadPredefinedBots} from "../../actions/firewall";

class DomainContentRuleModal extends React.Component {
    state = {
        loading: false,

        name: '',
        priority: 0,
        date_starts: moment().utc().toISOString(),
        date_expires: null,
        include_path_match_type: 'ALL',
        include_paths: '',
        exclude_path_match_type: 'NONE',
        exclude_paths: '',
        pattern_match_type: 'TEXT',
        pattern: '',
        replacement: '',
        conditions: [],
        random: Date.now(),
        action: 'REPLACE_CONTENT',
        url: '',
        replacement_limit: 1,
        case_sensitive: false,

        ruleLoaded: false,
        loadingRule: false,
    };

    countries = countryList().getData();

    predefinedBots = [];

    componentDidMount() {
        this.props.loadPredefinedBots((res) => {
            this.predefinedBots = res.data.map((bot) => {
                return { label: bot.name, value: bot.value };
            });
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.showModal && !this.state.ruleLoaded && !this.state.loadingRule && this.props.ruleAction === 'EDIT') {
            this.loadContentRule();
        }
    }

    loadContentRule() {
        this.setState({ loading: true, loadingRule: true });

        this.props.loadContentRule(this.props.domainGuid, this.props.activeRule, (res) => {
            this.setState({
                ...res.data,
                include_paths: res.data.include_paths.join('\n'),
                exclude_paths: res.data.exclude_paths.join('\n'),
                loading: false, ruleLoaded: true, loadingRule: false});
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ loading: false, ruleLoaded: true, loadingRule: false });
            }
        });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps !== prevState) {
            return nextProps;
        }

        return null;
    }

    closeModal(reload = false) {
        this.setState({
            loading: false,

            name: '',
            priority: 0,
            date_starts: moment().utc().toISOString(),
            date_expires: null,
            include_path_match_type: 'ALL',
            include_paths: '',
            exclude_path_match_type: 'NONE',
            exclude_paths: '',
            pattern_match_type: 'TEXT',
            pattern: '',
            replacement: '',
            conditions: [],
            random: Date.now(),
            action: 'REPLACE_CONTENT',
            url: '',
            replacement_limit: 1,
            case_sensitive: false,

            ruleLoaded: false,
            loadingRule: false,
        });

        this.props.closeModal();

        if(reload) {
            this.props.reloadContentRules();
        }
    }

    updateCondition(condition_block_index, condition_index, data) {
        let conditions = this.state.conditions;

        conditions = conditions.map((condition_block, _condition_block_index) => {
            if(_condition_block_index === condition_block_index) {
                return condition_block.map((condition, _condition_index) => {
                    if(_condition_index === condition_index) {
                        return data;
                    }

                    return condition;
                });
            }

            return condition_block;
        });

        this.setState({ conditions });
    }

    addAndCondition() {
        let conditions = this.state.conditions;
        conditions.push([ { field: 'http.request.user_agent', operator: 'EQUALS', value: '' } ]);
        this.setState({ conditions });
    }

    addOrCondition(conditionAndBlockIndex) {
        let conditions = this.state.conditions;

        conditions = conditions.map((condition_block, _condition_block_index) => {
            if(_condition_block_index === conditionAndBlockIndex) {
                condition_block.push({ field: 'http.request.user_agent', operator: 'EQUALS', value: '' });
                return condition_block;
            }

            return condition_block;
        });

        this.setState({ conditions });
    }

    removeCondition(conditionAndBlockIndex, conditionIndex) {
        let conditions = this.state.conditions;

        let conditionsBlock = [];

        for(let i = 0; i < this.state.conditions.length; i++) {
            if(conditionAndBlockIndex === i) {
                let conditionsList = [];

                for(let j = 0; j < this.state.conditions[i].length; j++) {
                    if(conditionIndex !== j) {
                        conditionsList.push(this.state.conditions[i][j]);
                    }
                }

                if(conditionsList.length > 0) {
                    conditionsBlock.push(conditionsList);
                }
            } else {
                conditionsBlock.push(this.state.conditions[i]);
            }
        }

        conditions = conditionsBlock;

        this.setState({ conditions, random: Date.now() });
    }

    submitContentRule(close = false) {
        let name = this.state.name.trim();

        if(name.length === 0) {
            return message.error('Please enter name!');
        }

        let date_starts = this.state.date_starts;

        if(date_starts === null) {
            return message.error('Pleas enter start date!')
        }

        let pattern = '';
        let replacement = '';
        let url = '';

        if(this.state.action === 'REPLACE_CONTENT') {
            pattern = this.state.pattern.trim();

            if(pattern.length === 0) {
                return message.error('Please enter pattern!')
            }

            replacement = this.state.replacement.trim();

            if(replacement.length === 0) {
                return message.error('Please enter replacement content!');
            }
        } else {
            url = this.state.url.trim();

            if(url.length === 0) {
                return message.error('Please enter URL!');
            }
        }

        const include_paths = this.state.include_paths
            .split('\n')
            .map(item => item.trim())
            .filter(item => item !== '');

        const exclude_paths = this.state.exclude_paths
            .split('\n')
            .map(item => item.trim())
            .filter(item => item !== '');

        let data = {
            name: name,
            priority: this.state.priority,
            date_starts: date_starts,
            date_expires: this.state.date_expires,
            include_path_match_type: this.state.include_path_match_type,
            include_paths: include_paths,
            exclude_path_match_type: this.state.exclude_path_match_type,
            exclude_paths: exclude_paths,
            pattern_match_type: this.state.pattern_match_type,
            pattern: pattern,
            replacement: replacement,
            url: url,
            action: this.state.action,
            conditions: this.state.conditions,
            replacement_limit: this.state.replacement_limit,
            case_sensitive: this.state.case_sensitive,
        }

        this.setState({ loading: true });

        if(this.props.ruleAction === 'EDIT') {
            this.props.updateContentRule(this.props.domainGuid, this.state.guid, data, () => {
                message.success('Content rule successfully updated!');

                if(close) {
                    this.closeModal(true);
                } else {
                    this.props.reloadContentRules();
                }

                this.setState({ loading: false });

            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    displayErrors(err.response.data);
                    this.setState({ loading: false });
                }
            });
        } else {
            this.props.createContentRule(this.props.domainGuid, data, () => {
                message.success('Content rule successfully created!');

                this.closeModal(true);

                this.setState({ loading: false });

            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    displayErrors(err.response.data);
                    this.setState({ loading: false });
                }
            });
        }

    }

    addFirstCondition() {
        this.setState({ conditions: [[ { field: 'http.request.user_agent', operator: 'EQUALS', value: '' } ]]})
    }

    render() {
        const { TextArea } = Input;
        const { Option } = Select;

        let andBlockCount = this.state.conditions.length;

        let conditions = this.state.conditions.map((conditionAndBlock, conditionAndBlockIndex) => {
            let orBlockCount = conditionAndBlock.length;
            let orBlocks = conditionAndBlock.map((condition, conditionIndex) => {
                return <Fragment key={conditionIndex + this.state.random}>
                    <div className='logic-block or'>
                        <Row key={conditionIndex + this.state.random}>
                            <Col span={20}>
                                <FirewallRuleCondition
                                    countries={this.countries}
                                    predefinedBots={this.predefinedBots}
                                    key={conditionIndex}
                                    condition={condition}
                                    exclude={['http.host', 'http.request.uri']}
                                    onChange={(data) => this.updateCondition(conditionAndBlockIndex, conditionIndex, data)} />
                            </Col>
                            <Col flex="auto" align='right'>
                                <Button.Group>
                                    {(conditionAndBlockIndex + 1) === andBlockCount ? <Button onClick={() => this.addAndCondition()}>AND</Button> : ''}
                                    <Button onClick={() => this.addOrCondition(conditionAndBlockIndex, conditionIndex)}>OR</Button>
                                    <Button onClick={() => this.removeCondition(conditionAndBlockIndex, conditionIndex)} icon={<DeleteOutlined />} />
                                </Button.Group>
                            </Col>
                        </Row>
                    </div>
                    { (conditionIndex + 1) < orBlockCount ? <div className='logic-block-separator or'><span>OR</span></div> : ''}
                </Fragment>
            });

            return <Fragment key={conditionAndBlockIndex}>
                <div className='logic-block and'>{orBlocks}</div>
                { (conditionAndBlockIndex + 1) < andBlockCount ? <div className='logic-block-separator and'><span>AND</span></div> : '' }
            </Fragment>;
        });

        if(this.state.conditions.length === 0) {
            conditions = <div style={{
                height: '100px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '8px'
            }}>
                <div style={{color: '#898989'}}>No conditions defined yet. The rule will run on every page visit within the path scope.</div>
                <div><Button icon={<PlusOutlined />} onClick={() => this.addFirstCondition()}>Add Condition</Button></div>
            </div>
        }

        return(
            <Modal
                centered
                title={(this.props.ruleAction === 'EDIT' ? 'Edit' : 'Create') + ' Content Rule'}
                open={this.props.showModal}
                width={1100}
                destroyOnClose={true}
                footer={<Space>
                    <Button type={this.props.ruleAction !== 'EDIT' ? 'primary' : ''} loading={this.state.loading} disabled={this.state.loading} onClick={() => this.submitContentRule()}>{this.props.ruleAction === 'EDIT' ? 'Save Rule' : 'Create Rule'}</Button>
                    {this.props.ruleAction === 'EDIT' ? <Button type='primary' loading={this.state.loading} disabled={this.state.loading} onClick={() => this.submitContentRule(true)}>Save Rule & Close</Button> : ''}
                </Space>}
                confirmLoading={this.state.loading}
                bodyStyle={{backgroundColor: '#f9f9f9', maxHeight: '700px', overflowY: 'scroll'}}
                onCancel={() => this.closeModal()}>

                <Form layout='vertical'>

                    <Card title='Rule Setup' size='small' style={{marginBottom: '10px'}}>
                        <Row gutter={[16, 16]}>
                            <Col span={16}>
                                <Form.Item label='Rule Name' extra={<small>Give your rule a descriptive name for easy identification.</small>}>
                                    <Input value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label='Rule priority' extra={<small>Higher numbers execute first.</small>}>
                                    <Input value={this.state.priority} type='number' defaultValue={0} min={0} onChange={(e) => this.setState({ priority: e.target.value })} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>

                    <Card title='Scheduling' size='small' style={{marginBottom: '10px'}}>
                        <p>Determine when this rule becomes active and when it expires.</p>
                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <Form.Item label='Start date' extra={<small>UTC timezone</small>}>
                                    <DatePicker
                                        style={{width: '100%'}}
                                        format="YYYY-MM-DD HH:mm:ss"
                                        defaultValue={moment(this.state.date_starts)}
                                        showTime={{ defaultValue: moment('00:00:00', 'HH:mm') }}
                                        onChange={(e) => this.setState({ date_starts: e !== null ? moment(e).utc().toISOString() : null})} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label='End date (optional)' extra={<small>Leave empty for no expiration</small>}>
                                    <DatePicker
                                        style={{width: '100%'}}
                                        format="YYYY-MM-DD HH:mm:ss"
                                        defaultValue={this.state.date_expires !== null ? moment(this.state.date_expires) : null}
                                        showTime={{ defaultValue: moment('00:00:00', 'HH:mm').utc() }}
                                        onChange={(e) => this.setState({ date_expires: e !== null ? moment(e).utc().toISOString() : null})} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>

                    <Card title='Path Matching' size='small' style={{marginBottom: '10px'}}>

                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <Form.Item label='Apply to pages' extra={<small>Define which URL paths this rule should monitor.</small>}>
                                    <Select value={this.state.include_path_match_type} onChange={(value) => this.setState({ include_path_match_type: value })}>
                                        <Option value='ALL'>All pages</Option>
                                        <Option value='EXACT'>Exact pages</Option>
                                        <Option value='STARTS_WITH'>Pages start with</Option>
                                        <Option value='ENDS_WITH'>Pages end with</Option>
                                        <Option value='CONTAINS'>Pages contain</Option>
                                        <Option value='REGEX'>Regex</Option>
                                    </Select>
                                </Form.Item>
                                {this.state.include_path_match_type !== 'ALL' ? <Form.Item extra={<small>One {this.state.include_path_match_type === 'REGEX' ? 'pattern' : 'page'} per row</small>}>
                                    <TextArea value={this.state.include_paths} onChange={(e) => this.setState({ include_paths: e.target.value}) } />
                                </Form.Item> : ''}
                            </Col>
                            <Col span={12}>
                                <Form.Item label='Exclude pages' extra={<small>Optional: Exclude specific pages from this rule.</small>}>
                                    <Select value={this.state.exclude_path_match_type} onChange={(value) => this.setState({ exclude_path_match_type: value })}>
                                        <Option value='NONE'>None</Option>
                                        <Option value='EXACT'>Exact pages</Option>
                                        <Option value='STARTS_WITH'>Pages start with</Option>
                                        <Option value='ENDS_WITH'>Pages end with</Option>
                                        <Option value='CONTAINS'>Pages contain</Option>
                                        <Option value='REGEX'>Regex</Option>
                                    </Select>
                                </Form.Item>
                                {this.state.exclude_path_match_type !== 'NONE' ? <Form.Item extra={<small>One {this.state.exclude_path_match_type === 'REGEX' ? 'pattern' : 'page'} per row</small>}>
                                    <TextArea value={this.state.exclude_paths} onChange={(e) => this.setState({ exclude_paths: e.target.value}) } />
                                </Form.Item> : ''}
                            </Col>
                        </Row>

                    </Card>

                    <Card title='Rule Conditions' size='small' style={{marginBottom: '10px'}}>
                        {conditions}
                    </Card>


                    <Card title='Rule Action' size='small'>
                        <Radio.Group
                            defaultValue={this.state.action}
                            onChange={(e) => this.setState({ action: e.target.value })}
                            value={this.state.action}>
                            <Radio.Button value='REPLACE_CONTENT'>Replace content</Radio.Button>
                            <Radio.Button value='LOAD_URL'>Load URL</Radio.Button>
                        </Radio.Group>

                        <div style={{padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '5px', marginTop: '10px'}}>
                            {this.state.action === 'REPLACE_CONTENT' ? <>
                                <Row gutter={[16, 16]}>
                                    <Col span={8}>
                                        <Form.Item label='Search with'>
                                            <Select defaultValue={this.state.pattern_match_type} value={this.state.pattern_match_type} onChange={(value) => this.setState({ pattern_match_type: value })}>
                                                <Option value='TEXT'>Text</Option>
                                                <Option value='REGEX'>Regex</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label='Replacement limit' extra={<small>Maximum number of replacements</small>}>
                                            <Input
                                                type='number'
                                                value={this.state.replacement_limit}
                                                onChange={(e) => this.setState({ replacement_limit: e.target.value })}
                                                min={1} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label='Case sensitive' extra={<small>Should the text case matter or not</small>}>
                                            <Switch
                                                defaultChecked={this.state.case_sensitive}
                                                checked={this.state.case_sensitive}
                                                onChange={(value) => this.setState({ case_sensitive: value })} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Form.Item label='Find' extra={<small> {this.state.pattern_match_type === 'REGEX' ? 'The pattern to find in the page source. Uses PCRE2-compatible regular expressions and can match text or HTML markup.' : 'The text or HTML to find in the page source. You can match plain text or exact HTML markup.'}</small>}>
                                    <Input value={this.state.pattern} placeholder={this.state.pattern_match_type === 'REGEX' ? 'pbn\\s+hosting' : 'PBN hosting'} onChange={(e) => this.setState({ pattern: e.target.value}) } />
                                </Form.Item>
                                <Form.Item label='Replace with' extra={<small>Content that will be used to replace the found pattern. Supports HTML, JS, CSS, and plain text.</small>}>
                                    <TextArea rows={7} placeholder={this.state.pattern_match_type === 'REGEX' ? '<a href="https://priorityprospect.com">$1</a>' : '<a href="https://priorityprospect.com">PBN hosting</a>'} value={this.state.replacement} onChange={(e) => this.setState({ replacement: e.target.value}) } />
                                </Form.Item>
                            </> : ''}

                            {this.state.action === 'LOAD_URL' ? <Form.Item label='Source URL' extra={<small>URL to load content from.</small>}>
                                <Input value={this.state.url} placeholder='https://priorityprospect.com' onChange={(e) => this.setState({ url: e.target.value}) } />
                            </Form.Item> : ''}
                        </div>
                    </Card>

                </Form>
            </Modal>
        );
    }
}

export default connect(null, { createContentRule, updateContentRule, loadPredefinedBots, loadContentRule })(DomainContentRuleModal);